EmojiProvider = require 'app/scripts/lib/emoji-provider'
EmojiProviderComponent = require('./emoji-provider-component')
NimbleEmoji = require('emoji-mart/dist-es/components/emoji/nimble-emoji').default
React = require 'react'
_ = require 'underscore'

module.exports = class TrelloEmoji extends React.Component
  @defaultProps:
    set: 'twitter'
    size: 16

  render: ->
    React.createElement EmojiProviderComponent, isSmallSpinner: true, (data) =>
      React.createElement NimbleEmoji, _.extend {},
        @props,
        {
          data,
          backgroundImageFn: EmojiProvider.getSpritesheetsUrl
        }
